import { render, staticRenderFns } from "./GoodsReceiptView.vue?vue&type=template&id=4b939b3e&scoped=true&"
import script from "./GoodsReceiptView.vue?vue&type=script&lang=js&"
export * from "./GoodsReceiptView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsReceiptView.vue?vue&type=style&index=0&id=4b939b3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b939b3e",
  null
  
)

export default component.exports